import { render } from "./CreateXdrToken.vue?vue&type=template&id=77a599df"
import script from "./CreateXdrToken.vue?vue&type=script&lang=ts"
export * from "./CreateXdrToken.vue?vue&type=script&lang=ts"

import "json-tree-view/devtools.css?vue&type=style&index=0&lang=css"
script.render = render

export default script